import React, { useEffect } from 'react';
import { useGlobalContext } from '../../js/context';
import Button from '../button/Button.jsx';
import OverviewPageAnime from './OverviewPageAnime';
import { gtmTracking, gtm4Tracking } from '../../js/helpers';
import './OverviewPage.scss'
import ReactGA from 'react-ga4'

const OverviewPage = () => {
  const { changePageHandler } = useGlobalContext();

  useEffect(() => {
    OverviewPageAnime();
    ReactGA.send({hitType: "pageview", page: "OverviewPage", title: "OverviewPage"})
  }, []);

  return (
    <div className='tos-overview tos-container tos-hide-before-animated'>
      <div className='tos-overview__wrapper'>
        <h1 className='tos-overview__title'>
          <div className='tos-overview__title-sliced'>
            <span>A cigarette</span>{' '}
            <strong className='tos-overview__title-animated tos-overview__title-animated--burn tos-hide-before-animated'>
              burns
            </strong>{' '}
            <span>tobacco</span>
            <span className='tos-hide-desktop'>.</span>
          </div>
          <div className='tos-overview__title-sliced'>
            <span>Our heated tobacco product</span>{' '}
            <strong className='tos-overview__title-animated tos-overview__title-animated--heat tos-hide-before-animated'>
              heats
            </strong>{' '}
            <span>it</span>
            <span className='tos-hide-desktop'>.</span>
          </div>
        </h1>
        <div className='tos-overview__content'>
          <p className='tos-hide-before-animated'>
            This fundamental difference results in significantly reduced levels
            of harmful and potentially harmful constituents found in the aerosol
            it produces.
          </p>
          <p className='tos-hide-before-animated'>
            Our heated tobacco product is not risk-free and contains nicotine,
            which is addictive.
          </p>
        </div>
      </div>

      <div className='tos-overview__buttons'>
        <Button
          title='back'
          secondary={true}
          arrowPosition='left'
          onClick={() => {
            changePageHandler('home_page');
            gtm4Tracking({event: 'GA4_event_c_tfs_back'});
            gtmTracking('navigation', 'back');
          }}
          className='tos-overview__button-prev tos-hide-before-animated'
          hasHover
        >
          <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M13 8L3.5 8M3.5 8C3.5 8 6.13317 10.6332 7.5 12M3.5 8C3.5 8 6.13317 5.36683 7.5 4'
              stroke='white'
            />
          </svg>
        </Button>
        <Button
          title='enter experience'
          onClick={() => {
            changePageHandler('loading_page');
            gtm4Tracking({event: 'GA4_event_c_tfs_enter_experience'});
            gtmTracking('navigation', 'enter experience');

          }}
          className='tos-overview__button-next tos-hide-before-animated'
          hasHover
        />
      </div>
    </div>
  );
};

export default OverviewPage;
